import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

interface CustomerReview {
  customerReviewId: number;
  companyName: string;
  name: string;
  insta: string;
  review: string;
  status: boolean;
}

@Component({
  selector: 'app-success-story',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './success-story.component.html',
  styleUrl: './success-story.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('staggerFadeIn', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger('100ms', [
            animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class SuccessStoryComponent implements OnInit {
  customerReviews: CustomerReview[] = [];
  isLoading = true;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchCustomerReviews();
  }

  fetchCustomerReviews(): void {
    this.http.get<CustomerReview[]>('https://pos.qootk.com/api/ZOut/CustomerReview')
      .subscribe({
        next: (reviews) => {
          this.customerReviews = Array.isArray(reviews) ? reviews : [reviews];
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching customer reviews:', err);
          this.error = 'Failed to load customer reviews';
          this.isLoading = false;
        }
      });
  }
}
